"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var _lodash = _interopRequireDefault(require("lodash"));

var ContactsApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(ContactsApi, _BasicProviderApi);

  /**
   * Represents a Contact Api.
   * @constructor
   */
  function ContactsApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        sendWSMessage = _ref.sendWSMessage,
        _ref$globalCache = _ref.globalCache,
        globalCache = _ref$globalCache === void 0 ? false : _ref$globalCache;
    (0, _classCallCheck2.default)(this, ContactsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactsApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl,
      sendWSMessage: sendWSMessage,
      globalCache: globalCache
    }));
  }
  /**
   *
   * @param {Object} param0.options options for request - {size, from, sort, projection, bookName, tableName, bookAccountId}
   * @returns {Object} with properties data: contacts list, total: contacts count
   */


  (0, _createClass2.default)(ContactsApi, [{
    key: "getContactsList",
    value: function () {
      var _getContactsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(options) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/contacts',
                  queryParams: options,
                  errorName: 'ContactError'
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContactsList(_x) {
        return _getContactsList.apply(this, arguments);
      }

      return getContactsList;
    }()
    /**
     *
     * @description This method fetches the list of Contacts from specific provider with MarvinDev AccountId
     * Will be deleted after Contacts API allows support of cross-account calls
     * @param {Object} param0.options options for request - {size, from, sort, scroll, scroll_id, projection}
     * @returns {Array} of contacts list
     */

  }, {
    key: "getContacts",
    value: function () {
      var _getContacts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(options) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'get',
                  path: 'contacts/list-all',
                  queryParams: options,
                  errorName: 'ContactError'
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getContacts(_x2) {
        return _getContacts.apply(this, arguments);
      }

      return getContacts;
    }()
    /**
     *
     * @param {String} param0.contactId id of contact
     * @param {String} param1.bookName name of contact book
     * @param {Boolean} param2.useAlias if true - match contactId with aliases
     * @returns {Object} contact
     */

  }, {
    key: "getContact",
    value: function () {
      var _getContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref2) {
        var contactId, bookName, useAlias;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contactId = _ref2.contactId, bookName = _ref2.bookName, useAlias = _ref2.useAlias;
                _context3.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/contacts',
                  queryParams: {
                    contactId: contactId,
                    bookName: bookName,
                    useAlias: useAlias
                  },
                  errorName: 'ContactError'
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getContact(_x3) {
        return _getContact.apply(this, arguments);
      }

      return getContact;
    }()
    /**
     *
     * @param {String} param0.contactId id of contact
     * @param {String} param1.bookName name of contact book
     */

  }, {
    key: "deleteContact",
    value: function () {
      var _deleteContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref3) {
        var contactId, bookName;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                contactId = _ref3.contactId, bookName = _ref3.bookName;
                _context4.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/contacts',
                  queryParams: {
                    contactId: contactId,
                    bookName: bookName
                  },
                  errorName: 'ContactError'
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteContact(_x4) {
        return _deleteContact.apply(this, arguments);
      }

      return deleteContact;
    }()
    /**
     *
     * @param {Object} param0.contactData contact object with required fields contactId
     * @param {String} param1.bookName name of contact book
     * @param {Object} param2.returning return undated contact in response
     */

  }, {
    key: "updateContact",
    value: function () {
      var _updateContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref4) {
        var contactData, bookName, _ref4$returning, returning;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                contactData = _ref4.contactData, bookName = _ref4.bookName, _ref4$returning = _ref4.returning, returning = _ref4$returning === void 0 ? false : _ref4$returning;

                if (_lodash.default.has(contactData, 'contactId')) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('ContactId is required in contact data');

              case 3:
                _context5.next = 5;
                return this._callApi({
                  method: 'put',
                  path: '/contacts',
                  queryParams: {
                    returning: returning,
                    bookName: bookName
                  },
                  payload: contactData,
                  errorName: 'ContactError'
                });

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateContact(_x5) {
        return _updateContact.apply(this, arguments);
      }

      return updateContact;
    }()
    /**
     *
     * @param {Object} param0.contactData contact object with required fields contactId
     * @param {String} param1.bookName name of contact book
     * @param {Object} param2.returning return undated contact in response
     */

  }, {
    key: "patchContact",
    value: function () {
      var _patchContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref5) {
        var patchContactData, bookName, _ref5$returning, returning, contactId, contactData, CONTACT_PATCH_FIELDS, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, property, dataToAdd, existedData, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2, dataToRemove, _existedData;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                patchContactData = _ref5.patchContactData, bookName = _ref5.bookName, _ref5$returning = _ref5.returning, returning = _ref5$returning === void 0 ? false : _ref5$returning;

                if (_lodash.default.has(patchContactData, 'contactId')) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('ContactId is required in contact data');

              case 3:
                contactId = patchContactData.contactId;
                _context6.next = 6;
                return this.getContact({
                  contactId: contactId,
                  bookName: bookName
                });

              case 6:
                contactData = _context6.sent;

                if (!_lodash.default.isEmpty(contactData)) {
                  _context6.next = 9;
                  break;
                }

                throw new Error('Contact not found');

              case 9:
                CONTACT_PATCH_FIELDS = _lodash.default.chain(patchContactData).omit('contactId').keys().value();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context6.prev = 13;
                _iterator = CONTACT_PATCH_FIELDS[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context6.next = 53;
                  break;
                }

                property = _step.value;

                if (!_lodash.default.get(patchContactData, [property, "removeAll".concat(_lodash.default.upperFirst(property))])) {
                  _context6.next = 20;
                  break;
                }

                contactData[property] = [];
                return _context6.abrupt("continue", 50);

              case 20:
                dataToAdd = _lodash.default.get(patchContactData, [property, "add".concat(_lodash.default.upperFirst(property))]);

                if (_lodash.default.isEmpty(dataToAdd)) {
                  _context6.next = 48;
                  break;
                }

                existedData = contactData[property];

                if (!_lodash.default.isString(dataToAdd[0])) {
                  _context6.next = 27;
                  break;
                }

                contactData[property] = _lodash.default.uniq(_lodash.default.concat(existedData, dataToAdd));
                _context6.next = 48;
                break;

              case 27:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 30;

                _loop = function _loop() {
                  var identifier = _step2.value;

                  var existedIdentifierIdx = _lodash.default.findIndex(existedData, function (existedIdnt) {
                    return existedIdnt.val === identifier.val;
                  });

                  if (existedIdentifierIdx !== -1) {
                    existedData[existedIdentifierIdx] = {
                      val: identifier.val,
                      type: _lodash.default.uniq(_lodash.default.concat(existedData[existedIdentifierIdx].type, identifier.type))
                    };
                  } else {
                    existedData.push(identifier);
                  }
                };

                for (_iterator2 = dataToAdd[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _loop();
                }

                _context6.next = 39;
                break;

              case 35:
                _context6.prev = 35;
                _context6.t0 = _context6["catch"](30);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 39:
                _context6.prev = 39;
                _context6.prev = 40;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 42:
                _context6.prev = 42;

                if (!_didIteratorError2) {
                  _context6.next = 45;
                  break;
                }

                throw _iteratorError2;

              case 45:
                return _context6.finish(42);

              case 46:
                return _context6.finish(39);

              case 47:
                contactData[property] = existedData;

              case 48:
                dataToRemove = _lodash.default.get(patchContactData, [property, "remove".concat(_lodash.default.upperFirst(property))]);

                if (!_lodash.default.isEmpty(dataToRemove)) {
                  _existedData = contactData[property];

                  if (_lodash.default.isString(dataToRemove[0])) {
                    contactData[property] = _lodash.default.difference(_existedData, dataToRemove);
                  } else {
                    contactData[property] = _lodash.default.differenceBy(_existedData, dataToRemove, 'val');
                  }
                }

              case 50:
                _iteratorNormalCompletion = true;
                _context6.next = 15;
                break;

              case 53:
                _context6.next = 59;
                break;

              case 55:
                _context6.prev = 55;
                _context6.t1 = _context6["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context6.t1;

              case 59:
                _context6.prev = 59;
                _context6.prev = 60;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 62:
                _context6.prev = 62;

                if (!_didIteratorError) {
                  _context6.next = 65;
                  break;
                }

                throw _iteratorError;

              case 65:
                return _context6.finish(62);

              case 66:
                return _context6.finish(59);

              case 67:
                _context6.next = 69;
                return this._callApi({
                  method: 'put',
                  path: '/contacts',
                  queryParams: {
                    returning: returning,
                    bookName: bookName
                  },
                  payload: contactData,
                  errorName: 'ContactError'
                });

              case 69:
                return _context6.abrupt("return", _context6.sent);

              case 70:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[13, 55, 59, 67], [30, 35, 39, 47], [40,, 42, 46], [60,, 62, 66]]);
      }));

      function patchContact(_x6) {
        return _patchContact.apply(this, arguments);
      }

      return patchContact;
    }()
    /**
     *
     * @param {Object} param0.contactData contact object with required fields contactId and name
     * @param {String} param1.bookName name of contact book
    */

  }, {
    key: "createContact",
    value: function () {
      var _createContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref6) {
        var contactData, bookName;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                contactData = _ref6.contactData, bookName = _ref6.bookName;
                _context7.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/contacts',
                  queryParams: {
                    bookName: bookName
                  },
                  payload: contactData,
                  errorName: 'ContactError'
                });

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function createContact(_x7) {
        return _createContact.apply(this, arguments);
      }

      return createContact;
    }()
    /**
     *
     * @param {String} param0.toContact id of contact that main in merge
     * @param {String} param1.fromContacts id of contact that got to be delete after merge
     * @param {String} param2.bookName name of contact book
     */

  }, {
    key: "mergeContacts",
    value: function () {
      var _mergeContacts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref7) {
        var toContact, fromContacts, bookName;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                toContact = _ref7.toContact, fromContacts = _ref7.fromContacts, bookName = _ref7.bookName;
                _context8.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/contacts/merge',
                  payload: {
                    toContact: toContact,
                    fromContacts: fromContacts,
                    bookName: bookName
                  },
                  errorName: 'ContactError'
                });

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function mergeContacts(_x8) {
        return _mergeContacts.apply(this, arguments);
      }

      return mergeContacts;
    }()
    /**
     *
     * @param {Object} param0.searchData fields for query and options for request
     */

  }, {
    key: "searchContacts",
    value: function () {
      var _searchContacts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref8) {
        var searchData;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                searchData = _ref8.searchData;
                _context9.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/contacts/search',
                  payload: searchData,
                  errorName: 'ContactError'
                });

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function searchContacts(_x9) {
        return _searchContacts.apply(this, arguments);
      }

      return searchContacts;
    }()
    /**
     *
     * @param {String} param0.projection projection for get specified fields
     * @param {String} param1.bookName name of contact book
     */

  }, {
    key: "getUsersList",
    value: function () {
      var _getUsersList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10() {
        var _ref9,
            projection,
            bookName,
            _args10 = arguments;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _ref9 = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {}, projection = _ref9.projection, bookName = _ref9.bookName;
                _context10.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/users',
                  queryParams: {
                    projection: projection,
                    bookName: bookName
                  },
                  errorName: 'ContactsUserError'
                });

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getUsersList() {
        return _getUsersList.apply(this, arguments);
      }

      return getUsersList;
    }()
    /**
     *
     * @param {String} param0.userId id of user
     * @param {Array} param1.contactRuleGroups rule groups for user
     * @param {String} param2.bookName name of contact book
     * @param {String} param3.userAccountId accountId of user
     */

  }, {
    key: "updateUserContactRuleGroups",
    value: function () {
      var _updateUserContactRuleGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref10) {
        var userId, contactRuleGroups, bookName, userAccountId;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                userId = _ref10.userId, contactRuleGroups = _ref10.contactRuleGroups, bookName = _ref10.bookName, userAccountId = _ref10.userAccountId;
                _context11.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/contacts/users',
                  queryParams: {
                    userId: userId
                  },
                  payload: {
                    contactRuleGroups: contactRuleGroups,
                    bookName: bookName,
                    userAccountId: userAccountId
                  },
                  errorName: 'UserContactRuleGroupsError'
                });

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function updateUserContactRuleGroups(_x10) {
        return _updateUserContactRuleGroups.apply(this, arguments);
      }

      return updateUserContactRuleGroups;
    }()
    /**
     * @param {String} param0.userId userId
     * @param {Array} param1.addContactRuleGroups array of groups ids add to user groups
     * @param {Array} param2.removeContactRuleGroups array of groups ids remove to user groups
     * @param {String} param3.bookName name of contact book
     * @param {String} param4.userAccountId accountId of user
     * @returns {Object} user groups
     */

  }, {
    key: "patchUserContactRuleGroups",
    value: function () {
      var _patchUserContactRuleGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref11) {
        var userId, addContactRuleGroups, removeContactRuleGroups, bookName, userAccountId;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                userId = _ref11.userId, addContactRuleGroups = _ref11.addContactRuleGroups, removeContactRuleGroups = _ref11.removeContactRuleGroups, bookName = _ref11.bookName, userAccountId = _ref11.userAccountId;
                _context12.next = 3;
                return this._callApi({
                  method: 'patch',
                  path: '/contacts/users',
                  queryParams: {
                    userId: userId
                  },
                  payload: {
                    addContactRuleGroups: addContactRuleGroups,
                    removeContactRuleGroups: removeContactRuleGroups,
                    bookName: bookName,
                    userAccountId: userAccountId
                  },
                  errorName: 'UserContactRuleGroupsError'
                });

              case 3:
                return _context12.abrupt("return", _context12.sent);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function patchUserContactRuleGroups(_x11) {
        return _patchUserContactRuleGroups.apply(this, arguments);
      }

      return patchUserContactRuleGroups;
    }()
    /**
     *
     * @returns {Array} rule groups list
     */

  }, {
    key: "getContactRuleGroupsList",
    value: function () {
      var _getContactRuleGroupsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13() {
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/rule-groups',
                  errorName: 'ContactRuleGroupsError'
                });

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getContactRuleGroupsList() {
        return _getContactRuleGroupsList.apply(this, arguments);
      }

      return getContactRuleGroupsList;
    }()
    /**
     * @param {String} param0.groupId id of rule group
     * @returns {Object} rule group
     */

  }, {
    key: "getContactRuleGroup",
    value: function () {
      var _getContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref12) {
        var groupId;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                groupId = _ref12.groupId;
                _context14.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/rule-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getContactRuleGroup(_x12) {
        return _getContactRuleGroup.apply(this, arguments);
      }

      return getContactRuleGroup;
    }()
    /**
     * @param {String} param0.name name of rule group
     * @param {Array} param1.rules user permissions rules
     * @returns {Object} add stats
     */

  }, {
    key: "addContactRuleGroup",
    value: function () {
      var _addContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref13) {
        var name, rules;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                name = _ref13.name, rules = _ref13.rules;
                _context15.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/contacts/rule-groups',
                  payload: {
                    name: name,
                    rules: rules
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context15.abrupt("return", _context15.sent);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function addContactRuleGroup(_x13) {
        return _addContactRuleGroup.apply(this, arguments);
      }

      return addContactRuleGroup;
    }()
    /**
     * @param {String} param0.groupId id of rule group
     * @param {String} param1.name name of rule group
     * @param {Array} param2.rules user permissions rules
     * @returns {Object} update stats
     */

  }, {
    key: "updateContactRuleGroup",
    value: function () {
      var _updateContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref14) {
        var groupId, name, rules;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                groupId = _ref14.groupId, name = _ref14.name, rules = _ref14.rules;
                _context16.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/contacts/rule-groups',
                  payload: {
                    groupId: groupId,
                    name: name,
                    rules: rules
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateContactRuleGroup(_x14) {
        return _updateContactRuleGroup.apply(this, arguments);
      }

      return updateContactRuleGroup;
    }()
    /**
     * @param {String} param0.groupId id of rule group
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteContactRuleGroup",
    value: function () {
      var _deleteContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref15) {
        var groupId;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                groupId = _ref15.groupId;
                _context17.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/contacts/rule-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function deleteContactRuleGroup(_x15) {
        return _deleteContactRuleGroup.apply(this, arguments);
      }

      return deleteContactRuleGroup;
    }()
    /**
     * @param {String} param0.bookName name of contacts book
     * @returns {Object} number of records
     */

  }, {
    key: "getContactRecordsCount",
    value: function () {
      var _getContactRecordsCount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(_ref16) {
        var bookName;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                bookName = _ref16.bookName;
                _context18.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/count',
                  queryParams: {
                    bookName: bookName
                  },
                  errorName: 'ContactRecordCountError'
                });

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getContactRecordsCount(_x16) {
        return _getContactRecordsCount.apply(this, arguments);
      }

      return getContactRecordsCount;
    }()
    /**
     *
     * @returns {Object} {creckContactsInstalled: true or false}
     */

  }, {
    key: "checkContactsInstalled",
    value: function () {
      var _checkContactsInstalled = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19() {
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/check',
                  errorName: 'ContactError'
                });

              case 2:
                return _context19.abrupt("return", _context19.sent);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function checkContactsInstalled() {
        return _checkContactsInstalled.apply(this, arguments);
      }

      return checkContactsInstalled;
    }()
    /**
     *
     * @returns {Object} last migration data
     */

  }, {
    key: "getLastMigrationVersion",
    value: function () {
      var _getLastMigrationVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20() {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/last-migration-version',
                  errorName: 'ContactError'
                });

              case 2:
                return _context20.abrupt("return", _context20.sent);

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getLastMigrationVersion() {
        return _getLastMigrationVersion.apply(this, arguments);
      }

      return getLastMigrationVersion;
    }()
    /**
     *
     * @returns {Object} deployed contacts versions
     */

  }, {
    key: "getDeployedContactsVersion",
    value: function () {
      var _getDeployedContactsVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee21() {
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/contacts/deployed-versions',
                  errorName: 'ContactError'
                });

              case 2:
                return _context21.abrupt("return", _context21.sent);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getDeployedContactsVersion() {
        return _getDeployedContactsVersion.apply(this, arguments);
      }

      return getDeployedContactsVersion;
    }()
  }]);
  return ContactsApi;
}(_basic_provider.default);

var _default = ContactsApi;
exports.default = _default;